import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import BN from 'bignumber.js';
import stylesParent from '../../../../../../../components/Stake/frame/frame.module.scss';
import styles from '../../../../../../../components/Stake/frame/styles/stake/stake-settings.module.scss';
import Header from '../../../../../../../components/Stake/header';
import { formatToken } from '../../../../../../../helpers/token-helper';
import OmEthPolygonIcon from '../../../../../../../assets/images/tokens/om-eth.svg';
import { useGetTheme } from '../../../../../../../hooks/useGetTheme';
import * as omEthPolygonStakeActions from '../../../../../../../actions/om-eth-stake-actions-polygon';
import { toPowerOf } from '../../../../../../../blockchain/config';
import TextRow from '../../../../../../../components/Stake/frame/settings/text-row';
import InputRow from '../../../../../../../components/Stake/frame/settings/input-row';
import FooterBlock from '../../../../../../../components/Stake/frame/settings/footer-block';

const UnstakeSettings = () => {
  const dispatch = useDispatch();
  const colors = useGetTheme();

  const [amount, setAmount] = useState(`${toPowerOf}`);
  const [inputValue, setInputValue] = useState(amount);

  useEffect(() => {
    setInputValue(+new BN(amount).div(toPowerOf).toFixed(10, BN.ROUND_DOWN));
  }, [amount]);
  const { stakeBalance } = useSelector((state) => state.OMETHPOLYGONStake.stake);

  const handleAmountChange = (value) => {
    setAmount(value.amount);
  };

  const totalStake = `${formatToken(stakeBalance, 10)} QUICK OM/ETH`;

  return (
    <>
      <Header
        icon={OmEthPolygonIcon}
        title='QUICK OM/ETH-Unstaking'
        onClickBack={() => dispatch(omEthPolygonStakeActions.stakeReset())}
      />
      <div className={stylesParent.cardContent} style={{ color: colors.text }}>
        <div>
          <TextRow
            title='Current Total Stake:'
            text={totalStake}
            isAccent={true}
            isLargeMargin={true}
          />
        </div>
        <div className={styles.body}>
          <InputRow
            toPowerOf={toPowerOf}
            title='Unstake Amount'
            handleAmountChange={handleAmountChange}
            currency='QUICK OM/ETH'
            balance={stakeBalance}
            inputValue={inputValue}
          />

          <FooterBlock
            nextButtonClick={() => dispatch(omEthPolygonStakeActions.unstakeDetails({ amount }))}
          />
        </div>
      </div>
    </>
  );
};

export default UnstakeSettings;
